module.exports = __webpack_public_path__ + "static/media/298630.880c0912.png";